import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { ProductViewModel } from '~/lib/data-contract';
import { fetchProduct } from '~/lib/fetchProduct';
import { useFranchise } from '~/shared/utils';

export const useProduct = () => {
    const { queryKey, franchiseAPIPath } = useFranchise();
    const router = useRouter();

    const productId = router.query.productId as string || '';
    const productColorId = router.query.variantId as string || '';

    const productQueryKey =  ['product', { queryKey, productId, productColorId }];

    return useQuery<ProductViewModel, Error>(
        productQueryKey,
        () => fetchProduct({ productId, productColorId, franchiseAPIPath }),
        {
            enabled: Boolean(productId && productColorId),
            retry: false,
        }
    );
};
